// @ts-nocheck
import React, { useState } from 'react';
import { sx } from '../sx';

type Option = { id: string; label: string };

function Choice({ label, options, value, onChange }: { label: string; options: Option[]; value: string; onChange: (id: string) => void }) {
  return (
    <div role="radiogroup" aria-label={label} style={sx(`margin-top:14px`)}>
      <div style={sx(`font-size:11px;font-weight:500;letter-spacing:0.08em;text-transform:uppercase;color:var(--ink-4);margin-bottom:7px`)}>{label}</div>
      <div style={sx(`display:flex;flex-wrap:wrap;gap:6px`)}>
        {options.map(o => {
          const on = o.id === value;
          return (
            <button key={o.id} type="button" role="radio" aria-checked={on} onClick={() => onChange(o.id)} style={sx(`height:28px;padding:0 12px;border:1px solid ${on ? '#0052CD' : '#C8D4EA'};border-radius:999px;background:${on ? '#0052CD' : '#fff'};color:${on ? '#fff' : '#4D6389'};font-family:inherit;font-size:12px;cursor:pointer`)}>{o.label}</button>
          );
        })}
      </div>
    </div>
  );
}

export default function AddDriverModal({ sections, units, isTaken, onAdd, onClose }: { sections: Option[]; units: Option[]; isTaken: (name: string) => boolean; onAdd: (name: string, section: string, unit: string) => void; onClose: () => void }) {
  const [name, setName] = useState('');
  const [section, setSection] = useState(sections[0]?.id || 'acq');
  const [unit, setUnit] = useState(units[0]?.id || 'currency');
  const label = name.trim();
  const duplicate = !!label && isTaken(label);
  const canAdd = !!label && !duplicate;
  const submit = () => {
    if (!canAdd) return;
    onAdd(label, section, unit);
    onClose();
  };
  const onKey = e => {
    if (e.key === 'Enter') submit();
    else if (e.key === 'Escape') onClose();
  };

  return (
    <div onClick={onClose} style={sx(`position:fixed;inset:0;z-index:60;background:rgba(8,35,76,0.45);display:flex;align-items:center;justify-content:center;padding:24px`)}>
      <div role="dialog" aria-label="Add driver" onClick={e => e.stopPropagation()} style={sx(`width:100%;max-width:400px;background:#fff;border-radius:16px;box-shadow:0 30px 60px -25px rgba(8,35,76,0.5);padding:20px`)}>
        <div style={sx(`display:flex;align-items:center;gap:10px;margin-bottom:14px`)}>
          <div style={sx(`flex:1;min-width:0;font-size:15px;font-weight:600;color:var(--ink);letter-spacing:-0.01em`)}>Add driver</div>
          <button className="gmHover" onClick={onClose} aria-label="Close" style={sx(`flex:none;width:26px;height:26px;display:flex;align-items:center;justify-content:center;border:1px solid #DCE4F2;border-radius:999px;background:#fff;color:var(--ink-3);font-family:inherit;font-size:13px;line-height:1;cursor:pointer`)} data-hover="background:#F5F8FA">×</button>
        </div>
        <label style={sx(`display:block;font-size:11px;font-weight:500;letter-spacing:0.08em;text-transform:uppercase;color:var(--ink-4);margin-bottom:7px`)}>Driver name</label>
        <input
          className="gmFocus"
          autoFocus
          aria-label="Driver name"
          value={name}
          onChange={e => setName(e.target.value)}
          onKeyDown={onKey}
          placeholder="e.g. Retail orders"
          style={sx(`width:100%;height:38px;padding:0 12px;border:1px solid ${duplicate ? '#E5484D' : '#C8D4EA'};border-radius:8px;background:#fff;font-family:inherit;font-size:13px;color:var(--ink);outline:none;box-sizing:border-box`)}
        />
        {duplicate ? <p style={sx(`margin:8px 0 0;font-size:11.5px;line-height:1.45;color:#E5484D`)}>A driver with this name already exists.</p> : null}
        <Choice label="Section" options={sections} value={section} onChange={setSection} />
        <Choice label="Number type" options={units} value={unit} onChange={setUnit} />
        <p style={sx(`margin:14px 0 0;font-size:11.5px;line-height:1.45;color:var(--ink-4)`)}>Adds a manual row to the plan. It is saved in the app, not Snowflake. Every month is editable, including actuals, and accepts + or − values.</p>
        <div style={sx(`display:flex;justify-content:flex-end;gap:8px;margin-top:16px`)}>
          <button className="gmHover" onClick={onClose} style={sx(`height:32px;padding:0 14px;border:1px solid #C8D4EA;border-radius:999px;background:#fff;color:var(--ink-3);font-family:inherit;font-size:12.5px;cursor:pointer`)} data-hover="background:#F5F8FA">Cancel</button>
          <button onClick={submit} disabled={!canAdd} style={sx(`height:32px;padding:0 16px;border:none;border-radius:999px;background:${canAdd ? '#0052CD' : '#C8D4EA'};color:#fff;font-family:inherit;font-size:12.5px;font-weight:500;cursor:${canAdd ? 'pointer' : 'default'}`)}>Add driver</button>
        </div>
      </div>
    </div>
  );
}
